import { DateTime } from 'luxon'
import privateStorage from '@/store/privateStorage.js'

const STORAGE_KEY = 'kn.coachGreet'

async function save(greetFields) {
    const greet = {
        content: greetFields.content,
        relationshipId: greetFields.relationshipId ?? null,
        time: DateTime.utc().toString(),
        ...greetFields,
    }
    await privateStorage.setItem(STORAGE_KEY, JSON.stringify(greet))
}

async function load() {
    try {
        const greet = JSON.parse(await privateStorage.getItem(STORAGE_KEY))
        greet.time = DateTime.fromISO(greet.time)
        return greet
    } catch (err) {
        return {}
    }
}

async function clear() {
    await privateStorage.setItem(STORAGE_KEY, JSON.stringify({}))
}

function makeStoreMsg({ content }) {
    return {
        messageId: crypto.randomUUID(),
        role: 'assistant',
        content,
    }
}

export default { save, load, clear, makeStoreMsg }
